import {Component, ChangeDetectionStrategy} from '@angular/core';
import {Account} from "@app/_model";
import {AuthService} from '@app/_service';

@Component({
  standalone: true,
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [],
})
export class HomeComponent {

  constructor(
    private readonly authService: AuthService
  ) {
  }

  protected get account(): Account | null {
    return this.authService.accountValue;
  }
}
